import { useApp } from '../../context/AppContext';

export default function ConfirmDialog() {
  const { confirmDialog, resolveConfirm } = useApp();
  if (!confirmDialog) return null;

  const isDanger = confirmDialog.variant === 'danger';

  return (
    <div
      className="modal-overlay open"
      role="presentation"
      onClick={(e) => e.target === e.currentTarget && resolveConfirm(false)}
    >
      <div
        className="modal confirm-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-desc"
        style={{ width: '420px', maxWidth: 'calc(100vw - 32px)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <div className="modal-title" id="confirm-dialog-title">{confirmDialog.title}</div>
          <button
            type="button"
            className="modal-close"
            aria-label="ปิด"
            onClick={() => resolveConfirm(false)}
          >
            <i className="fa-solid fa-xmark" />
          </button>
        </div>
        <div className="modal-body" id="confirm-dialog-desc" style={{ whiteSpace: 'pre-wrap' }}>
          {confirmDialog.message}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-ghost" onClick={() => resolveConfirm(false)}>
            {confirmDialog.cancelLabel || 'ยกเลิก'}
          </button>
          <button
            type="button"
            className={`btn ${isDanger ? 'btn-danger' : 'btn-primary'}`}
            onClick={() => resolveConfirm(true)}
          >
            {confirmDialog.confirmLabel || 'ยืนยัน'}
          </button>
        </div>
      </div>
    </div>
  );
}
